var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.471 3.362a.667.667 0 00-.943 0L4.862 8.03a.667.667 0 000 .943l4.666 4.666a.667.667 0 00.943-.942L6.276 8.5l4.195-4.195a.667.667 0 000-.943z",
    fill: "#222"
  })));
};
export default SvgArrowLeft;